import React from "react";
import Newsletter_37 from "../component/Newsletter_37";

function Newsletter_37Container() {
  return <Newsletter_37 />;
}

export default Newsletter_37Container;
